
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import ExamList from "@/lib/model/exam/exam";
import ModalTitle from "@/lib/model/exam/modal-title";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import Decrypt from "@/lib/model/decryptParams/decryptParams";

@Component({
  components: {
    ModalHeader
  }
})
export default class ShowRepeatModal extends Vue {
  name = "show-repeat-modal";
  @Prop() private phone!: string;
  @Prop() private examId!: number;
  @Prop() private candidateId!: number;
  @Prop() private examName!: string;
  @Prop() private isVisible!: boolean;
  @Prop() private isEnableAi!: boolean;
  @Prop({ type: Boolean, default: true }) examTypeFlag!: boolean;

  scoreAll = 100;
  tableLoading = false;
  modalTitle: ModalTitle = new ModalTitle();
  reportGetForm: ExamGetForm = new ExamGetForm();
  repeatCandidateList = [];
  repeatCandidateListForm = new CandidateListForm();
  showScore = true;
  V = vuexStore;

  @Emit("on-close-more")
  handleClose() {
    console.log("handleClose");
  }

  closeModal() {
    this.handleClose();
  }

  mounted() {
    this.modalTitle.title =
      "候选人参加" + (this.examName ? this.examName : "") + "面试记录";
    this.modalTitle.hasDesc = false;
    this.reportGetForm.companyId = parseInt(Auth.companyId);
    this.getExamReport();
  }

  getExamReport() {
    this.tableLoading = true;
    this.reportGetForm.examId = this.examId;
    ExamList.examReportGet(this.reportGetForm)
      .then(res => {
        this.scoreAll = res.scoreAll;
      })
      .finally(() => {
        this.getRepeatList();
      });
  }

  submitStatusConvert(submitStatus: number, auditStatus: number) {
    if (submitStatus === 0) {
      return "未登记";
    } else if (submitStatus === 1) {
      return "答题中";
    } else if (submitStatus === 3) {
      return "已登记";
    } else if (submitStatus === 2) {
      return "已交卷";
    } else if (submitStatus === 5) {
      return "已评估";
    } else if (submitStatus === 4) {
      return "待评估";
    } else {
      if (auditStatus === 0) {
        return "待评估";
      } else if (auditStatus === 1) {
        return "通过";
      } else if (auditStatus === 2) {
        return "待定";
      } else if (auditStatus === 3) {
        return "拒绝";
      } else {
        return "待评估";
      }
    }
  }

  className(submitStatus: number, auditStatus: number) {
    if (submitStatus === 0) {
      return "submit-color-1";
    } else if (submitStatus === 1) {
      return "submit-color-2";
    } else if (submitStatus === 3) {
      return "submit-color-1";
    } else if (submitStatus === 2) {
      return "submit-color-3";
    } else if (submitStatus === 5) {
      return "audit-color-1";
    } else if (submitStatus === 4) {
      return "audit-color-1";
    } else {
      if (auditStatus === 0) {
        return "audit-color-1";
      } else if (auditStatus === 1) {
        return "audit-color-2";
      } else if (auditStatus === 2) {
        return "audit-color-3";
      } else if (auditStatus === 3) {
        return "audit-color-4";
      } else {
        return "audit-color-1";
      }
    }
  }

  auditStatusConvert(auditStatus: number, submitStatus: number) {
    if (submitStatus !== 2 && submitStatus !== 5) {
      return "-";
    } else {
      if (auditStatus === 0) {
        return "待评估";
      } else if (auditStatus === 1) {
        return "通过";
      } else if (auditStatus === 2) {
        return "待定";
      } else if (auditStatus === 3) {
        return "拒绝";
      } else {
        return "待评估";
      }
    }
  }

  auditStatusColor(auditStatus: number, submitStatus: number) {
    if (submitStatus !== 2 && submitStatus !== 5) {
      return "status-black";
    } else {
      if (auditStatus === 0) {
        return "audit-color-1";
      } else if (auditStatus === 1) {
        return "audit-color-2";
      } else if (auditStatus === 2) {
        return "audit-color-3";
      } else if (auditStatus === 3) {
        return "audit-color-4";
      } else {
        return "audit-color-1";
      }
    }
  }

  getRepeatList() {
    this.repeatCandidateListForm.asCompany = 0;
    this.repeatCandidateListForm.examId = this.examId;
    this.repeatCandidateListForm.phone = this.phone;
    this.repeatCandidateListForm.sortKey = "created_time";
    this.repeatCandidateListForm.sortDict = "desc";

    ExamList.getCandidateListNew({ candidateId: this.candidateId })
      .then(res => {
        this.repeatCandidateList = res.data.list;
      })
      .finally(() => {
        this.tableLoading = false;
      });
  }

  toSingleCandidateEvaluate(row: any) {
    const cid = Auth.companyId;
    const isF = row.examType === "test" ? 1 : undefined; //fsk模式
    // const previewUrl = `/exam/mark?examId=${row.examId}&companyId=${cid}&auditStatus=${row.auditStatus}&connectCode=${row.connectCode}`;
    const previewUrl = `/exam/mark?connectCode=${row.connectCode}${
      isF ? "&isF=1" : ""
    }`;
    window.open(previewUrl);
  }

  //报告页
  async candidateReport(row: any) {
    const isF = row.examType === "test" ? 1 : undefined; //fsk模式

    // this.$refs.result.open(row);
    // const previewUrl = `http://localhost:8080/candidate-info?connectCode=${row.connectCode}`;
    let previewUrl = `/candidate-info?connectCode=${row.connectCode}${
      isF ? "&isF=1" : ""
    }`;
    //补加tid鉴权字段
    try {
      await Decrypt.get({
        candidateId: String(row.candidateId)
      }).then(res => {
        previewUrl += "&tid=" + res.tid;
      });
    } catch (e) {
      this.$message.warning("获取tId失败");
      console.log(e);
    }

    //打开页面
    window.open(previewUrl);
  }
}
